import secureLocalStorage from "react-secure-storage";

import {clearGlitchTipUser} from "@/src/modules/core/lib/glitchtip";
import {queryClient} from "@/src/modules/core/lib/query-client";
import {meService} from "@/src/modules/core/services/me";
import {userPropertyService} from "@/src/modules/core/services/user-property";
import {shiftsService} from "@/src/modules/shifts/services";

import {useSessionStore} from "../store/session";

export function invalidateSessionState(): void {
  userPropertyService.clearUserProperty();
  clearGlitchTipUser();
  useSessionStore.setState({session: null});
  meService.clearMe();
  secureLocalStorage.clear();
  shiftsService.clear();
  queryClient.removeQueries();
}
